import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgForm } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MappingModel } from '../../models/userManagementModel/mapping.model';
import { UserManagementModel } from '../../models/userManagementModel/usermang.model';

import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { UserManagementService } from '../../service/user-management.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';

import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { TableColumn } from '../table/TableColumn';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class RolesComponent implements OnInit {
  public addRoleModel = new UserManagementModel();
  public mappingModel = new MappingModel(0, 0,);
  public roles: UserManagementModel[] = [];
  public excelRoles: UserManagementModel[] = [];
  public submenus: UserManagementModel[] = [];
  public pages: UserManagementModel[] = [];
  public employeesData: UserManagementModel[] = [];
  public loggedinUser: string = '';
  public errorMessage: string = '';
  public sucessMessage: string = '';
  private subscriptions: Subscription[] = [];
  public menusdata: UserManagementModel[] = [];
  public refreshing: boolean;
  public checkedactive: boolean = false;
  public selctedViews: MappingModel[] = [];
  public selctedViewsUncheck: MappingModel[] = [];
  public selctedEdits: MappingModel[] = [];
  public isTableExpanded = false;
  public showLoading: boolean;
  public roleid: string;
  public menuId: string;
  ordersTableColumns: TableColumn[];
  ordersTableColumns2: TableColumn[];
  ordersTableColumns3: TableColumn[];
  columnsData: any;
  pageColumnsData: any;
  actions: any;
  checkbox: any;
  actionButtons: any;

  public dataSourceRole = new MatTableDataSource<UserManagementModel>();
  public dataSourcePage = new MatTableDataSource<UserManagementModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  public displayedColumns = ['roleName', 'role_desc', 'email', 'comment', 'view', 'update', 'delete'];
  public displayedColumnsMenus = ['nav_page_name', 'nav_page_desc', 'page_order', 'created_dt', 'view', 'update'];

  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  isAccessDisabled: boolean = false;

  constructor(private globalService: GlobalService, private usermanagementService: UserManagementService,
    private authGaurdService: AuthGaurdService, private notificationService: NotificationService,
    public ete: ExportExcelService, private httpService: HttpClient, private dialog: MatDialog) { }

  ngOnInit(): void {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('roles');

    this.loggedinUser = this.authGaurdService.loginUser();
    console.log(' login name ', this.loggedinUser);
    this.getMenus();
    this.getRoles();
    this.getAllData();
    this.initializeColumns();
    this.initializeExcelHeaders();
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.roles;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    console.log(this.excelRoles);
    for (let js of this.excelRoles) {
      delete js.id;
      delete js.role_status;
      delete js.page_nav_id;
      delete js.parent_page_id;
      delete js.submenus;
      delete js.mapping_id;
      delete js.userroleid;
      delete js.page_id;
      delete js.del_acc;
      delete js.status;
      delete js.created_by;
      delete js.updated_dt;
      delete js.updated_by;
      delete js.sub_page_id;
      delete js.sub_nav_page_name;
      delete js.sub_nav_page_desc;
      delete js.sub_created_dt;
      delete js.nav_page_route;
      delete js.editMode;
      delete js.role_id;
      delete js.access_level;
      delete js.created_dt;
      delete js.comment;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelRoles.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'Roles&Pages',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  public getRoles(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.usermanagementService.getRoles().subscribe(
        (response: UserManagementModel[]) => {
          this.dataSourceRole.data = response as UserManagementModel[];
          this.roles = response;
          this.roles = this.roles.sort((a, b) => (a.role_name < b.role_name) ? -1 : 1);
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getAllData(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.usermanagementService.getAllData().subscribe(
        (response: UserManagementModel[]) => {
          this.dataSourceRole.data = response as UserManagementModel[];
          this.excelRoles = JSON.parse(JSON.stringify(response));
          console.log(this.excelRoles);
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public onEditPage(editPage: UserManagementModel): void {
    this.addRoleModel = editPage;
    this.clickButton('openPageEdit');
  }

  public onDeletePage(id: number): void {
    if (confirm("Are you sure to delete this page")) {
      this.subscriptions.push(
        this.usermanagementService.deleteRole(id).subscribe(
          (response: CustomHttpRespone) => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
            this.getRoles();
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
      );
    }
  }



  public onEditRole(editRole: UserManagementModel): void {
    console.log(editRole);
    this.addRoleModel = editRole;
    this.clickButton('openRoleEdit');
  }

  public onDeleteRole(id: number): void {
    if (confirm("Are you sure to delete this role")) {
      this.subscriptions.push(
        this.usermanagementService.deleteRole(id).subscribe(
          (response: CustomHttpRespone) => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
            this.getRoles();
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
      );
    }
  }

  public onUpdatePage(): void {
    const formData = this.usermanagementService.createPageForm(this.addRoleModel);
    this.subscriptions.push(
      this.usermanagementService.updatePage(formData).subscribe(
        (response: UserManagementModel) => {
          this.clickButton('closeEditPageModalButton');
          this.getPages();
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Page updated successfully`);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public onUpdateRole(): void {
    const formData = this.usermanagementService.createRoleForm(this.addRoleModel);
    this.subscriptions.push(
      this.usermanagementService.updateRole(formData).subscribe(
        (response: UserManagementModel) => {
          this.clickButton('closeEditRoleModalButton');
          this.getRoles();
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Role updated successfully`);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  getId(id: string) {
    this.roleid = id;
    console.log("rece = " + id);
    this.getPages();
  }

  getMenuId(id: string) {
    this.menuId = id;
    console.log("getMenuId=" + id);
    this.getSubMenus();
  }

  public getSubMenus(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.usermanagementService.getSubMenus(this.roleid, this.menuId).subscribe(
        (response: UserManagementModel[]) => {
          //this.dataSourceMajorRegions.data = response as RegionsModel[];
          this.submenus = response;
          //console.log("submenus=" + JSON.stringify(this.submenus));
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getPages(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.usermanagementService.getPages().subscribe(
        (response: UserManagementModel[]) => {
          this.dataSourcePage.data = response as UserManagementModel[];
          this.pages = response;
         // console.log(this.pages);
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getMenus() {
    this.usermanagementService.getMenus()
      .subscribe((data: any) => {
        this.menusdata = data;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public addNewRole(roleForm: NgForm): void {
    this.showLoading = true;
    const formData = this.usermanagementService.createRoleForm(roleForm.value);
    this.subscriptions.push(
      this.usermanagementService.addRole(formData).subscribe(
        (response: UserManagementModel) => {
          this.getRoles();
          this.clickButton('new-role-close');
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Role added successfully`);
          roleForm.reset();
          this.showLoading = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.showLoading = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    );
  }

  public addPage(pageForm: NgForm): void {
    this.showLoading = true;
    const formData = this.usermanagementService.createPageForm(pageForm.value);
    this.subscriptions.push(
      this.usermanagementService.addPage(formData).subscribe(
        (response: UserManagementModel) => {
          this.getMenus();
          this.clickButton('new-page-close');
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Navigation Page added successfully`);
          pageForm.reset();
          this.showLoading = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.showLoading = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public saveNewPage(): void {
    this.clickButton('new-page-save');
  }
  public saveNewRole(): void {
    this.clickButton('new-role-save');
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  ngAfterViewInit(): void {
    this.dataSourceRole.sort = this.sort;
    this.dataSourceRole.paginator = this.paginator;
    this.dataSourcePage.paginator = this.paginator;
  }

  public customSort = (event) => {
    console.log(event);
  }

  public doFilter = (value: string) => {
    this.dataSourceRole.filter = value.trim().toLocaleLowerCase();
    this.dataSourcePage.filter = value.trim().toLocaleLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  viewEditAccess(user: any, values: any, name: string) {
    console.log("viewEditAccess user = " + JSON.stringify(user.row));
    var stat: string;
    var formData: FormData;

    if (user.name === 'View') {
      //console.log("Inside View");
      //this.assignPageToRoleViews();
      if (user.row.view_acc === true) {
        stat = "n";
      } else {
        stat = "y";
      }

      console.log(this.roleid);
      console.log(user.row.sub_page_id);
      console.log(stat);
      console.log(user.row.parent_page_id);

      formData = this.usermanagementService.createMapForm(this.roleid, user.row.sub_page_id, stat,user.row.parent_page_id);
      this.subscriptions.push(
        this.usermanagementService.updateAccessStatusViews(formData).subscribe(
          (response: UserManagementModel) => {
            this.getSubMenus();
            this.usermanagementService.getMenuListByRole(localStorage.getItem('CURRENT_USERROLE_SESSION')).subscribe();
            this.notificationService.sendNotification(NotificationType.SUCCESS, `View access updated successfully`);
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
      );
    } else if (user.name === 'Edit') {
      console.log("Inside Edit");
      if (user.row.edit_acc === true) {
        stat = "n";
      } else {
        stat = "y";
      }
      formData = this.usermanagementService.createMapForm(this.roleid, user.row.sub_page_id, stat,user.row.parent_page_id);
      this.subscriptions.push(
        this.usermanagementService.updateAccessStatusEdits(formData).subscribe(
          (response: UserManagementModel) => {
            this.getSubMenus();
            this.usermanagementService.getMenuListByRole(localStorage.getItem('CURRENT_USERROLE_SESSION')).subscribe();
            this.notificationService.sendNotification(NotificationType.SUCCESS, `Edit access updated successfully`);
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
      );
    } else {
      console.log("Inside else");
    }
    console.log("this.roleid = " + this.roleid);
    console.log("user.row.sub_page_id = " + user.row.sub_page_id);
    console.log("stat = " + stat);


  }

  rowAction(row: any) {
    console.log(" row ....", row.row.id, "=== val  ", row.value);
    if (row.value === 'View') {
      this.getId(row.row.id)
    }
    if (row.value === 'Update') {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.onEditRole(row.row);
      }

    }
    else if (row.value === 'Delete') {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.onDeleteRole(row.row.id);
      }

    }
  }

  innerRowAction(row: any) {
    console.log(" row ....", row);
    if (row.value === 'View') {
      this.getMenuId(row.row.page_nav_id)
    }
    else if (row.value === 'Update') {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.onEditPage(row.row);
      }

    }
    else if (row.value === 'Delete') {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.onDeletePage(row.row.page_nav_id);
      }

    }
  }

  actionOnButton(action: any) {
    
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }
    
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns3 = this.columnsData.SubMenuColumns;
        this.ordersTableColumns2 = this.columnsData.PagesColumns;
        this.ordersTableColumns = this.columnsData.RolesColumns;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    this.actions = [
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      }
      ,
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }

    ]

    this.checkbox = [
      {
        name: 'View',
        dataKey: 'sub_page_id',
        position: 'right',
        isSortable: false
      },
      {
        name: 'Edit',
        dataKey: 'sub_page_id',
        position: 'right',
        isSortable: false
      }

    ]

    this.actionButtons = [
      {
        name: 'Add Role',
        class: 'btn btn-success btn-xs'
      }
      // ,
      // {
      //   name: 'Add Page',
      //   class: 'btn btn-default btn-xs'
      // }
    ]
  }

}
